const mrpReabHeader = [
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'centro-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'centro-nome',
        show: true
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material',
        show: true
      },
      {
        name: 'Status',
        id: 'produto-status',
        show: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'Atual',
        id: 'estoque-atual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Pedidos em Transito',
        id: 'estoque-pedidos-transito',
        show: true,
        isNumeric: true
      },
      {
        name: 'Cobertura Atual',
        id: 'estoque-cobertura-atual',
        show: true,
        isNumeric: true
      },
      {
        name: 'Curva',
        id: 'estoque-curva-abc',
        show: true
      },
      {
        name: 'CD',
        id: 'estoque-cd',
        show: true,
        isNumeric: true
      },
      {
        name: 'Quantidade Sugerida',
        id: 'estoque-quantidade-sugerida',
        show: true,
        isNumeric: true
      },
      {
        name: 'Peso',
        id: 'estoque-peso',
        show: true,
        isNumeric: true
      }
    ]
  }
]

export default mrpReabHeader
